import { useState, useEffect } from "react";
import React from "react";

const initialState = {
  name: "",
  email: "",
  message: "",
  phone: ""
};

export const Contact = (props) => {
  const [{ name, email, message, phone }, setState] = useState(initialState);
  const [status, setStatus] = useState({
    submitting: false,
    showSuccess: false,
    error: null
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setState((prevState) => ({ ...prevState, [name]: value }));
  };
  
  const clearState = () => setState({ ...initialState });
  
  // Effect to hide success message after 3 seconds
  useEffect(() => {
    let timer;
    if (status.showSuccess) {
      timer = setTimeout(() => {
        setStatus(prev => ({ ...prev, showSuccess: false }));
      }, 3000);
    }
    return () => clearTimeout(timer);
  }, [status.showSuccess]);
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus({
      submitting: true,
      showSuccess: false,
      error: null
    });
  
    const formData = { name, email, phone, message };
  
    try {
      const response = await fetch("https://technosunenterprises.com/api/contact", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });
  
      const data = await response.json();
      if (response.ok) {
        setStatus({
          submitting: false,
          showSuccess: true,
          error: null
        });
        clearState();
      } else {
        setStatus({
          submitting: false,
          showSuccess: false,
          error: data.error || "Failed to send message"
        });
      }
    } catch (error) {
      console.error("Error:", error);
      setStatus({
        submitting: false,
        showSuccess: false,
        error: "Something went wrong. Please try again later."
      });
    }
  };
  
  return (
    <div>
      <div id="contact">
        <div className="container">
          <div className="col-md-8">
            <div className="row">
              <div className="section-title">
                <h2>Get In Touch</h2>
                <p>
                  Please fill out the form below to send us an email and we will
                  get back to you as soon as possible.
                </p>
              </div>
              <form name="sentMessage" validate onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        type="text"
                        id="name"
                        name="name"
                        value={name}
                        className="form-control"
                        placeholder="Name"
                        required
                        onChange={handleChange}
                      />
                      <p className="help-block text-danger"></p>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        type="email"
                        id="email"
                        name="email"
                        value={email}
                        className="form-control"
                        placeholder="Email"
                        required
                        onChange={handleChange}
                      />
                      <p className="help-block text-danger"></p>
                    </div>
                  </div>
                </div>
                <div className="form-group">
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    value={phone}
                    className="form-control"
                    placeholder="Phone"
                    required
                    onChange={handleChange}
                  />
                  <p className="help-block text-danger"></p>
                </div>
                <div className="form-group">
                  <textarea
                    name="message"
                    id="message"
                    value={message}
                    className="form-control"
                    rows="4"
                    placeholder="Message"
                    required
                    onChange={handleChange}
                  ></textarea>
                  <p className="help-block text-danger"></p>
                </div>
                <div id="success"></div>
                <div className="form-submit-container" style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                  <button 
                    type="submit" 
                    className="btn btn-custom btn-lg"
                    disabled={status.submitting}
                    style={{ position: 'relative' }}
                  >
                    {status.submitting ? (
                      <>
                        <span style={{ visibility: 'hidden' }}>Send Message</span>
                        <div className="spinner" style={{
                          position: 'absolute',
                          top: '50%',
                          left: '50%',
                          transform: 'translate(-50%, -50%)',
                          width: '20px',
                          height: '20px',
                          border: '3px solid rgba(255,255,255,0.3)',
                          borderRadius: '50%',
                          borderTop: '3px solid #fff',
                          animation: 'spin 1s linear infinite'
                        }}></div>
                      </>
                    ) : 'Send Message'}
                  </button>
                  
                  {status.showSuccess && (
                    <div className="success-message" style={{
                      backgroundColor: '#4CAF50',
                      color: 'white',
                      padding: '10px 15px',
                      borderRadius: '4px',
                      display: 'inline-block',
                      transition: 'opacity 0.5s ease-in-out'
                    }}>
                      Message sent successfully!
                    </div>
                  )}
                  
                  {status.error && (
                    <div className="error-message" style={{
                      backgroundColor: '#F44336',
                      color: 'white',
                      padding: '10px 15px',
                      borderRadius: '4px',
                      display: 'inline-block'
                    }}>
                      {status.error}
                    </div>
                  )}
                </div>
              </form>
            </div>
          </div>
          <div className="col-md-3 col-md-offset-1 contact-info">
            <div className="contact-item">
              <h3>Contact Info</h3>
              <p>
                <span>
                  <i className="fa fa-map-marker"></i> Address
                </span>
                {props.data ? props.data.address : "loading"}
              </p>
            </div>
            <div className="contact-item">
              <p>
                <span>
                  <i className="fa fa-phone"></i> Phone
                </span>{" "}
                {props.data ? props.data.phone : "loading"}
              </p>
            </div>
            <div className="contact-item">
              <p>
                <span>
                  <i className="fa fa-envelope-o"></i> Email
                </span>{" "}
                {props.data ? props.data.email : "loading"}
              </p>
            </div>
          </div>
        </div>
      </div>
      <style jsx>{`
        @keyframes spin {
          0% { transform: translate(-50%, -50%) rotate(0deg); }
          100% { transform: translate(-50%, -50%) rotate(360deg); }
        }
      `}</style>
    </div>
  );
};